import * as React from 'react';
import { Circle } from 'lucide-react';
import { cn } from '@/utils';

const RadioGroup = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & { value?: string; defaultValue?: string; onValueChange?: (value: string) => void }
>(({ className, children, value, defaultValue, onValueChange, ...props }, ref) => {
  return (
    <div
      ref={ref}
      role="radiogroup"
      className={cn('grid gap-2', className)}
      {...props}
    >
      {children}
    </div>
  );
});
RadioGroup.displayName = 'RadioGroup';

const RadioGroupItem = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>(({ className, children, checked, ...props }, ref) => (
  <div className="relative inline-flex items-center">
    <input
      ref={ref}
      type="radio"
      checked={checked}
      className={cn(
        'peer aspect-square h-4 w-4 rounded-full border border-primary text-primary ring-offset-background focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 appearance-none',
        className
      )}
      {...props}
    />
    <div className={cn(
      'absolute left-0 top-0 h-4 w-4 flex items-center justify-center pointer-events-none',
      checked ? 'opacity-100' : 'opacity-0'
    )}>
      <Circle className="h-2 w-2 fill-current text-current" />
    </div>
  </div>
));
RadioGroupItem.displayName = 'RadioGroupItem';

export { RadioGroup, RadioGroupItem };